module.exports = __webpack_public_path__ + "static/media/comment.c23d399a.svg";